import React from "react";
import Paper from "@mui/material/Paper";
import Draggable from "react-draggable";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Divider from "@mui/material/Divider";

const PaperComponent = (props) => {
  const nodeRef = React.useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
};

/**
 *
 * @param {Boolean} modalVisible determines if Modal should be visible
 * @param {String} modalTitle title for modal window
 * @param {Function} handleCancelModal function to make modal invisible
 * @param {React.FC} content modal content
 * @param {React.FC} actions modal actions
 * @returns our standard popup/draggable modal
 */
const DraggableModal = (props) => {
  const hideClose = props.hideClose ? props.hideClose : false
  let paperProps = {
    sx: {
      width: props.width ? props.width : "30%",
      height: props.height ? props.height : "auto",
      borderRadius: props.borderRadius ? props.borderRadius : 0
    },
  };

  return (
    <Dialog
      maxWidth="100%"
      open={props.modalVisible}
      PaperComponent={PaperComponent}
      PaperProps={{ ...paperProps }}
      aria-labelledby="draggable-dialog-title"
    >
      <DialogTitle style={{ cursor: "move" }} sx={{ fontSize: 16 }}>
        {props.modalTitle ? props.modalTitle : ""}
      </DialogTitle>
      {!hideClose && (
        <IconButton
          aria-label='close'
          onClick={props.handleCancelModal}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
      )}
      <Divider />
      {props.content ? <DialogContent sx={{
        maxWidth: props.maxWidth ? props.maxWidth : "800px",
        width: "100%",
        padding: '20px 12px',
        overflowX: "hidden",
      }}
      >{props.content}</DialogContent> : <></>}
      {props.actions ? (
        <DialogActions style={{ justifyContent: props.justifyActions || "center" }}>
          {props.actions}
        </DialogActions>
      ) : (
        <></>
      )}
    </Dialog>
  );
};

export default DraggableModal;
